<div *ngIf="isBlackFridayDeal" class="relative mb-2">
    <kb-picture
        src="https://www.artsupplies.co.uk/vendure-assets/black-friday-page-image-24__preview.webp?preset=full"
    ></kb-picture>
    <div class="bf-wrapper absolute rounded-full text-white font-bold text-center">
        <div class="bf-qualifier" *ngIf="rrpDiscountQualifier">UP TO</div>
        <div class="bf-rrp">{{ rrpDiscount }}</div>
        <div class="bf-label">OFF RRP</div>
    </div>
</div>
<div *ngIf="isJanuarySaleDeal" class="relative mb-2">
    <kb-picture
        src="https://www.artsupplies.co.uk/vendure-assets/january-sale-page-discount-image-2__preview.webp?preset=large"
    ></kb-picture>
    <div class="bf-wrapper absolute rounded-full text-white font-bold text-center">
        <div class="bf-qualifier" *ngIf="rrpDiscountQualifier">UP TO</div>
        <div class="bf-rrp">{{ rrpDiscount }}</div>
        <div class="bf-label">OFF RRP</div>
    </div>
</div>
<div
    *ngIf="offerCollections?.length"
    class="bg-white rounded border border-eastern relative inline-block mt-2 inline-flex flex-wrap items-center items-stretch"
>
    <div
        *ngFor="let offer of offerCollections"
        class="px-2 text-sm text-primary-800 flex justify-center flex-col"
        [title]="offer.name"
    >
        <a [routerLink]="['/c', offer.slug]" class="cursor-pointer text-link"> {{ offer.name }}</a>
        <vsf-dropdown *ngIf="offer.description && offer.description !== '<p></p>'">
            <button vsfDropdownTrigger class="btn-icon">
                <fa-icon [icon]="info" size="sm" class="mr-1"></fa-icon> offer details
            </button>
            <div class="px-4" vsfDropdownContent>
                <div [innerHTML]="offer.description" class="prose-sm"></div>
            </div>
        </vsf-dropdown>
    </div>
    <div
        class="text-sm rounded rounded-l-none bg-eastern text-white px-2 py-0.5 inline-block flex items-center gap-0.5"
        *ngIf="rrpDiscount"
    >
        <span *ngIf="rrpDiscountQualifier">Up to</span>
        <span>{{ rrpDiscount }}</span>
        <span>off RRP</span>
    </div>
</div>
